import { Video } from 'excelsis-video'

type VideoPreviewProps = {
  src: string
  poster: string
}

export const VideoPreview = ({ src, poster }: VideoPreviewProps) => {
  return (
    <Video
      src={src}
      style={{
        width: '100%',
        height: '100%',
        '& video': { transform: 'scale(2)', cursor: 'auto' },
      }}
      poster={poster}
      // @ts-ignore
      muted
      previewMode
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      <Video.TimeLine
        style={{
          bottom: '8px',
          right: 8,
          left: 8,
          width: 'calc(100% - 16px)',
          height: 4,
        }}
      />
    </Video>
  )
}
